import { useContext } from 'react';
import UiContext from './UiContext';

interface UiContextProps {
  isSidebarOpen: boolean;
  toggleSidebar: () => void;
  isSidebarCollapsed: boolean;
  toggleSidebarCollapse: () => void;
}

const useUiContext = (): UiContextProps => {
  return useContext(UiContext);
};

export default useUiContext;
